<template>
  <DataListStateful
    title="Водители"
    resource="drivers"
    store="drivers"
    :columns="columns"
    :filter-options="filter"
  />
</template>

<script>
export default {
  data() {
    return {
      columns: [
        { title: "Ид", name: "id", sortable: false },
        { title: "Имя", name: "name", sortable: true },
        { title: "Фамилия", name: "surname", sortable: true },
        {
          title: "Телефон",
          name: "phones",
          type: "text-array",
          sortable: true,
          maxLength: 20,
        },
        {
          title: "Перевозчик",
          name: "carrier",
          dataPath: "Carrier.Title",
          sortable: true,
        },
        {
          title: "Viber",
          name: "viber",
          sortable: true,
        },
      ],
      filter: {
        name: {
          title: "Имя",
          type: "text",
        },
        surname: {
          title: "Фамилия",
          type: "text",
        },
        phone: {
          title: "Телефон",
          type: "text",
        },
        carrier: {
          title: "Перевозчик",
          type: "reference",
          resource: "carriers",
        },
        viber: {
          title: "Viber",
          type: "text",
        },
      },
    };
  },
};
</script>
